var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClusterPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.545 32.318c-7.393-7.394-7.393-19.38 0-26.773 7.393-7.393 19.38-7.393 26.773 0 7.393 7.393 7.393 19.38 0 26.773L21.965 42.67a4.291 4.291 0 01-6.068 0L5.545 32.318z",
    fill: "#3366EC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    transform: "rotate(-90 19 19)",
    fill: "#fff",
    r: 13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClusterPin);
export default __webpack_public_path__ + "static/media/cluster-pin.d3ab2922.svg";
export { ForwardRef as ReactComponent };